module.exports = __webpack_public_path__ + "img/logo.4d48f889.png";